const ServerHelper = {
  ApiUrl: "https://maytechseguridad.com",
};

export default ServerHelper;
